module.exports = __webpack_public_path__ + "static/media/me.bda50512.JPG";